var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInActivePatient({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.888672,
    y: 0.484375,
    width: 51,
    height: 51,
    rx: 14,
    fill: "#F04545",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.3898 11.1094C22.4925 11.1094 19.3242 14.2778 19.3242 18.175C19.3242 21.9978 22.314 25.0919 26.2113 25.2257C26.3303 25.2108 26.4494 25.2108 26.5386 25.2257C26.5683 25.2257 26.5833 25.2257 26.613 25.2257C26.6279 25.2257 26.6279 25.2257 26.6427 25.2257C30.4507 25.0919 33.4406 21.9978 33.4555 18.175C33.4555 14.2778 30.2871 11.1094 26.3898 11.1094Z",
    fill: "#F04545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9445 29.1844C29.7944 26.4177 23.0262 26.4177 18.8464 29.1844C16.9573 30.4489 15.916 32.1594 15.916 33.989C15.916 35.8186 16.9573 37.5144 18.8315 38.7639C20.914 40.1622 23.651 40.8613 26.388 40.8613C29.125 40.8613 31.862 40.1622 33.9445 38.7639C35.8188 37.4996 36.86 35.8039 36.86 33.9593C36.8452 32.1297 35.8188 30.4339 33.9445 29.1844Z",
    fill: "#F04545"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2539 36.1155L28.5207 31.8516",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5215 36.1155L24.2547 31.8516",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInActivePatient);
export default __webpack_public_path__ + "static/media/InActivePatient.bbe44a81aaf03e228e99c5cb83c6cc5c.svg";
export { ForwardRef as ReactComponent };